import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Td from './Td';
import Tr from './Tr';
export const Wrapper = styled.div `
  display: flex;
  text-align: left;
  justify-content: flex-start;
  padding: 10px;
  word-break: break-word;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  white-space: pre-wrap;
`;
export const Title = styled.span `
  display: inline-flex;
  white-space: nowrap;
  margin: 0 5px 0 0;
  color: ${({ theme }) => theme.colors.grey100_1};
  font-weight: 500;
  + * {
    width: 100%;
  }
`;
const AdditionalRow = ({ title, text, dataTestId, className }) => (_jsx(Tr, { children: _jsx(Td, { type: 'sub', children: _jsxs(Wrapper, { "data-testid": dataTestId, className: className, children: [_jsxs(Title, { children: [title, ": "] }), text] }) }) }));
export default AdditionalRow;
